import React, { useEffect, useState } from 'react';
import Table from '../Subscription/Table';
import { styles } from '../Subscription/styles';

const ServiceHistoryComp = () => {
  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const storedSubscriptions = JSON.parse(localStorage.getItem('subscriptions')) || [];
    setSubscriptions(storedSubscriptions);
  }, []);

  return (
    <div className='p-0 m-0 box-border'>
      <div className='w-[98%]  mx-auto px-6 py-8 bg-white rounded-xl'>
        <div className='flex justify-between p-2'>
          <div className='w-120 text-4xl font-semibold text-blue-700' style={styles.interText}>
            Service History
          </div>
        </div>
        <Table subscriptions={subscriptions} />
      </div>
    </div>
  );
};

export default ServiceHistoryComp
